var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 10.4348H31.0045C28.7438 4.342 22.8791 0 15.9997 0C11.5813 0 7.58177 1.79119 4.68652 4.68681L9.73884 10.4348Z",
    fill: "#338AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 21.5652H31.0045C28.7438 27.658 22.8791 32 15.9997 32C11.5813 32 7.58177 30.2088 4.68652 27.3132L9.73884 21.5652Z",
    fill: "#338AF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68665 4.68628C-1.56173 10.9347 -1.56173 21.0653 4.68665 27.3138C7.26871 24.7317 9.75202 22.2484 16.0004 16L4.68665 4.68628Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/BS.035d4052.svg";
export { ForwardRef as ReactComponent };